const CommonTextEntries = {
  COMMON_LOADING: 'COMMON_LOADING',
  COMMON_DATE_TIME_FORMAT_LOCALE: 'COMMON_DATE_TIME_FORMAT_LOCALE',
  COMMON_CONFIRMATION_MODAL_CANCEL_BUTTON: 'COMMON_CONFIRMATION_MODAL_CANCEL_BUTTON',
  COMMON_CONFIRMATION_MODAL_CONFIRM_BUTTON: 'COMMON_CONFIRMATION_MODAL_CONFIRM_BUTTON',
  COMMON_CONFIRMATION_MODAL_PRIMARY_ERROR_MESSAGE: 'COMMON_CONFIRMATION_MODAL_PRIMARY_ERROR_MESSAGE',
  COMMON_CONFIRMATION_MODAL_SECONDARY_ERROR_MESSAGE: 'COMMON_CONFIRMATION_MODAL_SECONDARY_ERROR_MESSAGE',
  COMMON_NO_ACCESS_TITLE: 'COMMON_NO_ACCESS_TITLE',
  COMMON_NO_ACCESS_BODY: 'COMMON_NO_ACCESS_BODY',
  COMMON_NO_ACCESS_BACK_LINK: 'COMMON_NO_ACCESS_BACK_LINK',
  COMMON_PASSWORD_SHOW: 'COMMON_PASSWORD_SHOW',
  COMMON_PASSWORD_HIDE: 'COMMON_PASSWORD_HIDE',
  COMMON_INPUT_ERRORS_MISSING_VALUE: 'COMMON_INPUT_ERRORS_MISSING_VALUE',
  COMMON_INPUT_ERRORS_INVALID_URL: 'COMMON_INPUT_ERRORS_INVALID_URL',
  COMMON_INPUT_ERRORS_INVALID_EMAIL: 'COMMON_INPUT_ERRORS_INVALID_EMAIL',
  COMMON_COLLAPSIBLE_CONTENT_TEXT: 'COMMON_COLLAPSIBLE_CONTENT_TEXT',
};

export default CommonTextEntries;
